module.exports = __webpack_public_path__ + "img/lens-160-minus-04.d0f48f46.png";